/* eslint-disable guard-for-in */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';
import { Button, Col, Label, Row, Card, CardBody } from 'reactstrap';
import { useMutation, useQuery } from '@apollo/client';
import {
  APP_SETTINGS,
  UPDATE_APP_SETTINGS,
} from 'pages/Settings/SettingsGraphQL';
import Loader from 'components/common/Loader';
// import ReactSelect from 'components/Fields/ReactSelect';
import FormikInputField from 'components/Fields/FormikInputField';
import { modifiedUnderScore } from 'utils/constants';
import LoadingButton from 'components/common/LoadingButton';

// const validationSchema = Yup.object().shape({
//   // Define your validation schema here
//   // Example:
//   GST_VALUE: Yup.number().required('GST Value is required'),
//   TDS_VALUE: Yup.number().required('TDS Value is required'),
//   TDS_FLOOR: Yup.number().required('TDS Floor is required'),
//   // Add validations for other fields as needed
// });

const GeneralSetting = ({ type, drawerToggle }) => {
  const initialValues = {};

  const { data, loading, error } = useQuery(APP_SETTINGS, {
    variables: {
      filter: [{ key: 'type', value: type, type: 'STRING', op: 'EQ' }],
      pageNo: 0,
      pageSize: 10,
      sortCol: null,
      sortDirection: null,
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  const [updateAppSetting] = useMutation(UPDATE_APP_SETTINGS, {
    onCompleted: () => {
      toast.success('Update App Setting Successfully');
      drawerToggle();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      drawerToggle();
    },
  });

  data?.appSettings?.appSettings?.[0].values.forEach((value) => {
    initialValues[value.key] = value.value;
    initialValues[`${value.key}/type`] = {
      id: value.type,
      label: value.type,
    };
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const updateObj = {
      id: data?.appSettings?.appSettings?.[0]?.id,
      type: data?.appSettings?.appSettings?.[0].type,
      value: data?.appSettings?.appSettings?.[0].values?.map((item) => {
        return {
          key: item?.key,
          value: values[item?.key],
          type: values[`${item?.key}/type`]?.id,
        };
      }),
    };

    try {
      await updateAppSetting({
        variables: {
          ...updateObj,
        },
      });
    } catch (err) {
      toast.error(err);
    }
    setSubmitting(false);
  };

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.appSettings?.appSettings) return 'Data not available';

  const generateYupSchema = (initialValues) => {
    let obj = {};
    for (const key in initialValues) {
      if (!key.includes('/type')) {
        if (key === 'BID_APPROVAL_DURATION' || key === 'BID_DURATION') {
          obj = {
            ...obj,
            [key]: Yup.number()
              .integer(`${modifiedUnderScore(key)} must be an integer`)
              .required(`${modifiedUnderScore(key)} is required`),
          };
        } else if (
          key === 'CONTACT_SUPPORT_NUMBER' ||
          key === 'CONTACT_SUPPORT_EMAIL' ||
          key === 'CONTACT_SUPPORT_NAME'
        ) {
          if (key === 'CONTACT_SUPPORT_NUMBER') {
            obj = {
              ...obj,
              [key]: Yup.string()
                .required(`${modifiedUnderScore(key)} is required`)
                .matches(
                  /^(?:\+?\d[-\s.]?){8,15}$/,
                  `${modifiedUnderScore(key)} must be between 8 to 15 digits`,
                )
                .trim(),
            };
          } else if (key === 'CONTACT_SUPPORT_NAME') {
            obj = {
              ...obj,
              [key]: Yup.string()
                .required(`${modifiedUnderScore(key)} is required`)
                .trim(),
            };
          } else if (key === 'CONTACT_SUPPORT_EMAIL') {
            obj = {
              ...obj,
              [key]: Yup.string()
                .email(`${modifiedUnderScore(key)} must be enter a valid email`)
                .required(`${modifiedUnderScore(key)} is required`)
                .trim(),
            };
          }
        } else if (
          key === 'COMMISSION_QTY_UNIT_1' ||
          key === 'COMMISSION_QTY_UNIT_2' ||
          key === 'COMMISSION_QTY_UNIT_3' ||
          key === 'COMMISSION_QTY_UNIT'
        ) {
          obj = {
            ...obj,
            [key]: Yup.string().required(
              `${modifiedUnderScore(key)} is required`,
            ),
          };
        } else {
          obj = {
            ...obj,
            [key]: Yup.number().required(
              `${modifiedUnderScore(key)} is required`,
            ),
          };
        }
      }
    }

    const schema = Yup.object().shape({
      ...obj,
    });

    return schema;
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={generateYupSchema(initialValues)}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid, dirty }) => (
        <Form>
          <Card className="border shadow-none mb-4">
            <CardBody className="p-4">
              <div>
                {data?.appSettings?.appSettings?.[0]?.values.map((value) => (
                  <div key={value.key} className="mb-3">
                    <Row>
                      <Col sm={12}>
                        <Label>
                          {value.key === 'ORDER_APPROVAL_DURATION'
                            ? 'ORDER APPROVAL DURATION (in MIN)'
                            : modifiedUnderScore(value.key)}
                        </Label>
                      </Col>
                      {value.key === 'CONTACT_SUPPORT_NUMBER' ||
                      value.key === 'CONTACT_SUPPORT_EMAIL' ||
                      value.key === 'CONTACT_SUPPORT_NAME' ||
                      value.key === 'COMMISSION_QTY_UNIT_1' ||
                      value.key === 'COMMISSION_QTY_UNIT_2' ||
                      value.key === 'COMMISSION_QTY_UNIT_3' ||
                      value.key === 'COMMISSION_QTY_UNIT' ? (
                        <Col sm={12}>
                          <Field
                            id={value.key}
                            name={value.key}
                            label=""
                            type="text"
                            component={FormikInputField}
                          />
                        </Col>
                      ) : (
                        <>
                          <Col sm={12}>
                            <Field
                              id={value.key}
                              name={value.key}
                              label=""
                              type="number"
                              component={FormikInputField}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
          <div className="text-end mt-3 mb-1">
            <Button
              outline
              onClick={() => drawerToggle()}
              color="secondary"
              type="button"
              size="sm"
              className="me-2 mw-100"
            >
              Cancel
            </Button>
            <LoadingButton
              className="mw-100 loading-button"
              loading={isSubmitting}
              disabled={!isValid || !dirty || isSubmitting}
              color="warning"
              size="sm"
              type="submit"
            >
              Update
            </LoadingButton>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default GeneralSetting;
